import { REALMS, SKILLS } from "@mathtrain/engine";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useLoad } from "../lib/hooks";
import type { Growth } from "../lib/types";

/** Every strategy, grouped into realms of calculation, with what you've learned and where the coach says to start. */
export function Strategies() {
  const nav = useNavigate();
  const { data, error } = useLoad(() => api<Growth>("/growth"));
  if (error) return <main className="page bare"><div className="error">{error}</div></main>;
  if (!data) return <main className="page bare"><div className="empty">Loading…</div></main>;
  const recommended = new Set([...data.nextLessons, ...data.coach.plan.filter((p) => p.kind === "lesson").map((p) => p.lesson!)]);
  const focus = data.coach.focus;
  return <main className="page bare">
    <button className="btn quiet" onClick={() => nav("/grow", { replace: true })}>‹ Grow</button>
    <h1>Strategies</h1>
    <p className="mute">Short techniques for each kind of mental calculation. Start with the ones marked for you; the rest are here when you want them.</p>
    {REALMS.map((r) => {
      const ls = data.lessons.filter((l) => r.skills.includes(l.skill as never)).sort((a, b) => a.level - b.level);
      if (!ls.length) return null;
      const done = ls.filter((l) => l.learned).length;
      const mine = data.coach.skills.filter((s) => r.skills.includes(s.skill as never) && s.n >= 10);
      return <section key={r.key}>
        <h2>{r.name}</h2>
        <div className="card">
          <div className="card-head"><span className="mute small">{r.blurb}</span><span className="small mute">{done} of {ls.length}</span></div>
          {mine.length > 0 && <div className="small mute" style={{ marginBottom: 6 }}>{mine.map((s) => `${SKILLS[s.skill as keyof typeof SKILLS].name}: ${s.accuracy}% right`).join(" · ")}</div>}
          <ul className="lessons">
            {ls.map((l) => <li key={l.key}>
              <Link to={`/learn/${l.key}`} style={l.unlocked ? undefined : { opacity: 0.55 }}>
                <span className={"tick" + (l.learned ? " on" : "")} aria-hidden="true">{l.learned ? "✓" : ""}</span>
                <span><b>{l.title}</b>{recommended.has(l.key) && !l.learned && <span className="pill">For you</span>}
                  {l.skill === focus && !l.learned && !recommended.has(l.key) && <span className="pill quiet">Your focus skill</span>}
                  <small className="small mute"> {l.blurb}</small></span>
              </Link>
            </li>)}
          </ul>
        </div>
      </section>;
    })}
  </main>;
}
